import { z } from "zod";

/** Names of the CloudFront signed cookies set by `GET /explorer/v1/docs-access` (design D15). */
export const DOCS_ACCESS_COOKIES = [
  "CloudFront-Policy",
  "CloudFront-Signature",
  "CloudFront-Key-Pair-Id",
] as const;

/**
 * `GET /explorer/v1/docs-access` (task 13.4, design D15, spec integration-docs "[NFR] Access and
 * secrets"): any authenticated console user (any operator and role, Platform Administrators
 * included) receives the CloudFront signed cookies of the integration docs site as
 * `Set-Cookie` headers (`HttpOnly; Secure`), never in the body. The body says where the docs are
 * and until when the grant is valid; the SPA then opens `docs_url`.
 */
export const DocsAccessResponseV1 = z
  .object({
    docs_url: z.url(),
    expires_at: z.iso.datetime({ offset: true }),
  })
  .strict()
  .meta({ id: "DocsAccessResponseV1" });
export type DocsAccessResponseV1 = z.infer<typeof DocsAccessResponseV1>;
